import React, { useState } from 'react'
import { Link, useLocation, useParams } from 'react-router-dom';
import { GetAccess } from '../../../../Components/Utils/roles';
import { useFormik } from 'formik';
import { CancelButton, SubmitButton } from '../../../../Components/Utils/Buttons';
import FormikSelectTwo from '../../../../Components/Utils/Select';
import * as yup from 'yup';

import ViewIcon from '../../../../Components/Icons/ViewIcon';
import { Modal } from 'antd';
import ViewEquipments from '../../Settings/Equipments/ViewEquipments';
import UseGetDataSearch from '../../../../Components/Hooks/useFetchDataBySearch';
import UseGetDataSearchlist from '../../../../Components/Hooks/useFetchDataByListing';
import FireSuppressionLayout from './FireSupressionLayout';




function Equipments() {
       const { fireSuppressionViewId } = useParams();
         const [isViewModalOpen, setIsViewModalOpen] = useState(false); // View modal state 
                     
           const location = useLocation();
            const currentPage= location.state?.currentPage
            const searchQuery= location.state?.searchQuery
            const state = location.state;
          const [filter, setFilter] = useState(false);
              const [showFilterDialog, setShowFilterDialog] = useState(false);
                    const [filterProps, setFilterProps] = useState({
                         
                          brand:"",
                          
                        });
                        const [params, setParams] = useState({
                          // page: page,
                          // per_page: pageCount,
                          // search:searchQuery||"",
                         
                          brand:"",
                          
                        });
                        const clearFilter = ()=> {
                          setParams({...params,
                          brand:"",
                          
                        })
                       
                        formik.values.brand=""
                       
                      
                      
                            setFilter(false)
                        }
                      
                        const formik = useFormik({
                          enableReinitialize: true,
                          initialValues: filterProps,
                          validateOnChange: false,
                          validateOnBlur: false,
                          validationSchema: yup.object({
                            // email: yup.string().required('Email is required!'),
                          }),
                          onSubmit: async (value, { resetForm }) => {
                            console.log("ffff",value);
                            setParams({...params,brand:value.brand})
                            closeFilterDialog();
                            setFilter(true)
                            setFilterProps({
                             
                              brand:"",
                            
                            });
                          }
                        })
      
                        const closeFilterDialog = () => {
                          setShowFilterDialog(false);
                        };
                  const { data,getData,dataLoading } = UseGetDataSearchlist( `/contract/equipments/${fireSuppressionViewId}`,params);

                        const [viewModalData, setViewModalData] = useState(null);
                        const openViewModal = (data) => {
                          setViewModalData(data);
                          setIsViewModalOpen(true);
                        };
        return (
          <>
          <FireSuppressionLayout 
          setFilterOpen={setShowFilterDialog}
               ClearFilter={clearFilter}
               newfilter={true}
               isFilter={filter}
               BackAccess={GetAccess("")}
         
         >
           <div className="overflow-x-auto mt-0.5 rounded-md bg-white h-[calc(100vh-160px)]">
           <table className="min-w-full border-separate border-spacing-y-2 text-xs text-left">
             <thead>
               <tr className="text-black font-semibold">
                 <th className="px-4 py-2">Id</th>
                 <th className="px-4 py-2">Equipments</th>
                 <th className="px-4 py-2">Unit</th>
                 <th className="px-4 py-2">Brand</th>
                 <th className="px-4 py-2">Model No.</th>
                 <th className="px-4 py-2">Action</th>
               </tr>
             </thead>
             <tbody>
               {data?.map((item,i) => (
                 <tr key={item.equipmentId} className=" hover:bg-gray-50 rounded-md shadow-sm">
                   <td className="px-4 py-2">          <Link 
                    //  to={`/settings/equiments`}
                    onClick={() => openViewModal(item)}>
                      {data?.length - i}
                                               {/* <ViewIcon color="#048178" /> */}

                    </Link></td>
                      <td className="px-4 py-2">          
                      <Link 
                    //  to={`/settings/equiments`}
                    onClick={() => openViewModal(item)}>
                      {item.name}
                                               {/* <ViewIcon color="#048178" /> */}

                  </Link></td>
                   {/* <td className="px-4 py-2">{data.equipments}</td> */}
                   <td className="px-4 py-2">{item.unit}</td>
                   <td className="px-4 py-2">{item.brand}</td>
                   <td className="px-4 py-2">{item.model}</td>
                   <td className="px-4 py-2 text-gray-500">
                     <Link 
                    //  to={`/settings/equiments`}
                    onClick={() => openViewModal(item)}>
                                               <ViewIcon color="#048178" />

      </Link>
      </td>
                 </tr>
               ))}
             </tbody>
           </table>
         </div>
         </FireSuppressionLayout>
         {isViewModalOpen && (       
        <Modal
        open={isViewModalOpen}
        onCancel={()=>setIsViewModalOpen(false)}
        title={"View Equipment"}
        width="50%"
        centered
           className="my-modal"
     
        footer={[]}
      >
        <ViewEquipments data={viewModalData} open={isViewModalOpen} onCancel={() => setIsViewModalOpen(false)} />
   </Modal>
      )}
      
         {showFilterDialog && (
              <div className="fixed top-0 left-0 w-full h-full bg-gray-800 bg-opacity-50 z-[9999] flex justify-center items-center">
                <div className="animate-scale-in min-w-[40%] max-w-[80%] max-h-[80vh] bg-white py-4 px-6 rounded-md shadow-lg overflow-y-scroll">
                  <h2 className="text-xl mb-4">Filter </h2>
                  <form onSubmit={formik.handleSubmit}>
                    <div className="flex flex-col mb-4">
                    <FormikSelectTwo
                      type="text"
                      label="Unit"
                      placeholder="Choose unit"
                      // Options={unit}
                      formik={formik}
                      name="unit"
                      width="w-full"
                       />
                     <FormikSelectTwo
                      type="text"
                      label="Brand"
                      placeholder="Choose Brand"
                      // Options={brand}
                      formik={formik}
                      name="brand"
                      width="w-full"
                       />
                    </div>
                    <div className="flex justify-end gap-2">
                      <CancelButton handleClick={closeFilterDialog} />
                      <SubmitButton name="Apply" />
                    </div>
                  </form>
                </div>
              </div>
            )}
           </>
        )
}

export default Equipments